import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery } from '../shared';

/**
 * Calculator API - Base definition
 *
 * This is the base API slice for the Calculator service.
 * Provides reimbursement calculation endpoints.
 */
export const calculatorApi = createApi({
  reducerPath: 'calculatorApi',
  baseQuery: createAuthenticatedBaseQuery(process.env.REACT_APP_Calculators_API_BASE_URL),
  tagTypes: ['Calculation'],
  endpoints: () => ({}),
});
